module.exports = __webpack_public_path__ + "img/logo-prakerja.cad63abb.png";